export default "__VITE_ASSET__vRe_iwkM__"